import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import EditProgrammeForm from "../Forms/EditProgrammeForm";
class EditProgramme extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>Uppdatera program</ModalHeader>
        <ModalBody>
          <EditProgrammeForm
            reloadProgrammes={this.props.onComplete}
            dismissModal={this.props.toggle}
            programme={this.props.programme}
            classes={this.props.classes}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default EditProgramme;
